(function () {
  'use strict';
  function init(root) {
    if (root.hasAttribute('data-sak-header-ready')) return;
    var account = root.querySelector('.sak-header__account');
    var summary = account && account.querySelector('summary');
    var searchToggle = root.querySelector('.sak-header__search-toggle');
    var search = root.querySelector('.sak-header__search-form');
    var hover = window.matchMedia('(hover: hover) and (pointer: fine)');
    var closeTimer;
    var openedByHover = false;
    function closeSearch() {
      search.classList.remove('is-open');
      searchToggle.setAttribute('aria-expanded', 'false');
    }
    function closeAccount() { if (account) account.open = false; openedByHover = false; }
    if (account) {
      summary.addEventListener('click', function (event) {
        if (openedByHover && account.open && event.detail > 0) event.preventDefault();
        openedByHover = false;
      });
      account.addEventListener('mouseenter', function () {
        if (!hover.matches) return;
        clearTimeout(closeTimer);
        closeSearch();
        if (!account.open) openedByHover = true;
        account.open = true;
      });
      account.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          if (!account.contains(document.activeElement)) closeAccount();
        }, 140);
      });
      account.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!account.contains(document.activeElement) && !account.matches(':hover')) closeAccount();
        }, 0);
      });
      account.addEventListener('toggle', function () { if (account.open) closeSearch(); });
    }
    searchToggle.hidden = false;
    searchToggle.addEventListener('click', function () {
      var open = !search.classList.contains('is-open');
      closeAccount();
      search.classList.toggle('is-open', open);
      searchToggle.setAttribute('aria-expanded', String(open));
      if (open) search.querySelector('input[type="search"]').focus();
    });
    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) { closeAccount(); closeSearch(); }
      else if (account && !account.contains(event.target)) closeAccount();
    });
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (account && account.open) { closeAccount(); summary.focus(); }
      if (search.classList.contains('is-open')) { closeSearch(); searchToggle.focus(); }
    });
    root.setAttribute('data-sak-header-ready', '');
  }
  document.querySelectorAll('[data-sak-header]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-sak-header]').forEach(init);
  });
})();
